import { Footer } from "components/common"
import Sidebar from "../Sidebar"
import { useState } from "react"
import dynamic from "next/dynamic"
import { SkeletonTheme } from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"

const Navbar = dynamic(() => import("components/common/Navbar"), { ssr: false })
const NavbarBottom = dynamic(() => import("../NavBarBottom"), { ssr: false })

export default function Layout({ children }) {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  return (
    <main>
      <SkeletonTheme baseColor="#232323" highlightColor="#444444">
        <Navbar isMobile={isMobile} setIsMobile={setIsMobile} setIsCollapsed={setIsCollapsed} />
        <div className={`w-full flex justify-center`}>
          <div className={`w-full mt-[88px] max-[1199.5px]:mt-[68px] gap-10`}>
            <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} isMobile={isMobile} />
            <div
              className={`${
                isCollapsed
                  ? "max-[1199.5px]:ml-[0%] ml-[11%] min-[1400px]:ml-[10%] 2xl:ml-[9%] min-[1700px]:ml-[8%] min-[1850px]:ml-[7%]"
                  : "max-[1199.5px]:ml-[0%] ml-[26%] min-[1300px]:ml-[24%] min-[1400px]:ml-[22%] 2xl:ml-[20%] min-[1700px]:ml-[18%] min-[1850px]:ml-[16.5%]"
              }`}
            >
              <div className="min-h-screen max-md:min-h-full">
                {children && typeof children === "function" ? children({ isCollapsed }) : children}
              </div>
              <Footer />
            </div>
          </div>
        </div>
        <NavbarBottom />
      </SkeletonTheme>
    </main>
  )
}
